import {
  FilterOptionKeys,
  GroupByMode,
  SortingMode,
  TaskGroupBy,
} from '@griply/types';

export const inboxGroupOptions = [
  GroupByMode.None,
  GroupByMode.Priority,
  GroupByMode.Tag,
] as const satisfies TaskGroupBy[];

export const inboxSortOptions = [
  SortingMode.Custom,
  SortingMode.Priority,
  SortingMode.CreatedAt,
  SortingMode.Name,
] as const satisfies SortingMode[];

export const inboxFilters = [
  FilterOptionKeys.Priority,
  FilterOptionKeys.Tag,
  FilterOptionKeys.Duration,
] as const satisfies FilterOptionKeys[];
